import { render, staticRenderFns } from "./UploadForm.vue?vue&type=template&id=07ad973a&scoped=true"
import script from "./UploadForm.vue?vue&type=script&lang=ts"
export * from "./UploadForm.vue?vue&type=script&lang=ts"
import style0 from "./UploadForm.vue?vue&type=style&index=0&id=07ad973a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07ad973a",
  null
  
)

export default component.exports